import { AbstractMutableSetthfi6jds1k2h as AbstractMutableSet } from './AbstractMutableSet.mjs';
import { InternalHashMapmpvpylj0ut6l as InternalHashMap } from './InternalHashMap.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../Unit.mjs';
import { KtMutableSetwuwn7k5m570a as KtMutableSet } from './Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function init_kotlin_collections_HashSet(_this__u8e3s4) {
}
var HashSetClass;
function HashSet() {
  if (HashSetClass === VOID) {
    class $ extends AbstractMutableSet() {
      static fa(map) {
        var $this = this.b8();
        init_kotlin_collections_HashSet($this);
        $this.d3_1 = map;
        return $this;
      }
      static ga() {
        return this.fa(InternalHashMap().c9());
      }
      static ha(elements) {
        var $this = this.fa(InternalHashMap().ia(elements.q2()));
        var _iterator__ex2g4s = elements.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          $this.d3_1.a5(element, true);
        }
        return $this;
      }
      static ja(initialCapacity, loadFactor) {
        return this.fa(InternalHashMap().e9(initialCapacity, loadFactor));
      }
      static e3(initialCapacity) {
        return this.ja(initialCapacity, 1.0);
      }
      j2(element) {
        return this.d3_1.a5(element, true) == null;
      }
      s4() {
        this.d3_1.s4();
      }
      t2(element) {
        return this.d3_1.i9(element);
      }
      n1() {
        return this.d3_1.q2() === 0;
      }
      p1() {
        return this.d3_1.p9();
      }
      q2() {
        return this.d3_1.q2();
      }
    }
    initMetadataForClass($, 'HashSet', $.ga, VOID, [KtMutableSet()]);
    HashSetClass = $;
  }
  return HashSetClass;
}
//region block: exports
export {
  HashSet as HashSet2dzve9y63nf0v,
};
//endregion

//# sourceMappingURL=HashSet.mjs.map
